import { StepPackage } from '@samelogic/steps';
import { stepPackage } from '../../__tests__/MockPackage';
import { RemotePackageRepository } from './RemotePackageRepository';

describe('RemotePackageRepository', () => {
  let repository: RemotePackageRepository;
  beforeEach(() => {
    repository = new RemotePackageRepository();

    jest.resetModules();
    jest.restoreAllMocks();
  });
  describe('import()', () => {
    // Using relative file until I can figure out how to do a jest.mock
    // with a url.
    const url = './index.ts';
    //"https://cdn.jsdelivr.net/npm/@samelogic/micro-survey@0.6.0/dist/runner.js",

    describe('when import has no default', () => {
      beforeEach(() => {
        // eslint-disable-next-line @rushstack/hoist-jest-mock
        jest.mock(url, () => ({
          __esModule: true
        }));
      });
      it('should throw an error', async () => {
        await expect(repository.getPackageByUrl(url)).rejects.toThrow('Imported file has no default export');
      });
    });

    describe('when import is not in the right StepPackage format', () => {
      beforeEach(() => {
        // eslint-disable-next-line @rushstack/hoist-jest-mock
        jest.mock(url, () => ({
          __esModule: true,
          default: {}
        }));
      });
      it('should throw an error', async () => {
        await expect(repository.getPackageByUrl(url)).rejects.toThrow(
          'module or schema not found on default export'
        );
      });
    });

    describe('when import is a step package', () => {
      const expected = stepPackage;
      let got: StepPackage;
      beforeEach(async () => {
        // eslint-disable-next-line @rushstack/hoist-jest-mock
        jest.mock(url, () => ({
          __esModule: true,
          default: expected
        }));
        got = await repository.getPackageByUrl(url);
      });
      it('should return the step package', () => {
        expect(got).toBe(expected);
      });
    });
  });
});
